module.exports = __webpack_public_path__ + "static/media/me.95e5486f.svg";